import * as yup from 'yup'

export const LicenceHeldDurationValidation = yup.string()
